import { useEffect, useState } from "react";
import { hostedSession } from "../lib/hosted";

/**
 * Whether this pull request has a terraform panel.
 *
 * Which repositories those are is server configuration, so the client asks
 * rather than pattern-matching a name. The session request is already made and
 * memoised on every hosted page, so this costs a promise, not a round trip.
 *
 * It used to return the panel's path, because the panel was a page. It is a
 * sheet over the review page now, so there is no path to hand out — only
 * whether to offer it.
 */
export function useTerraformPanel(repository: string, pullNumber: number, enabled: boolean): boolean {
  const [managed, setManaged] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void hostedSession()
      .then((session) => {
        if (cancelled) return;
        setManaged((session.terraformRepositories ?? [])
          .some((candidate) => candidate.toLowerCase() === repository.toLowerCase()));
      })
      .catch(() => undefined);
    return () => { cancelled = true; };
  }, [enabled, pullNumber, repository]);
  return managed;
}
